<template>
  <div ref="byDate" style="min-height: 700px"></div>
</template>

<script>
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";

  export default {
    data () {
      return {
        chart : null,
      }
    },
    props : ['filterUrl'],
    mounted () {
      this.createChart();
    },
    watch : {
      "filterUrl" : function (){
        this.fetchData();
      }
    },
    methods : {
      fetchData () {
        let vm = this;
        var length = this.chart.data.length;

        this.$http.get('/api/h2/qr-registration/by-day?' + this.filterUrl)
        .then((resp)=>{
          var data = resp.data.data;
          for(var i = 0; i < data.length; i++){
            data[i].tanggal  = data[i].tanggal.slice(0,10)
          }
          vm.chart.addData(data, length);
        })
        .catch((err)=>{
          console.log(err);
        })

        // vm.chart.addData([
        //   {
        //     "count":1,
        //     "tanggal":"2020-04-01T17:00:00.000Z"
        //   },
        //   {
        //     "count":2,
        //     "tanggal":"2020-04-02T17:00:00.000Z"
        //   },
        //   {
        //     "count":7,
        //     "tanggal":"2020-04-05T17:00:00.000Z"
        //   },
        //   {
        //     "count":3,
        //     "tanggal":"2020-04-06T17:00:00.000Z"
        //   },
        //   {
        //     "count":3,
        //     "tanggal":"2020-04-07T17:00:00.000Z"
        //   },
        //   {
        //     "count":7,
        //     "tanggal":"2020-04-08T17:00:00.000Z"
        //   },
        //   {
        //     "count":6,
        //     "tanggal":"2020-04-09T17:00:00.000Z"
        //   },
        //   {
        //     "count":6,
        //     "tanggal":"2020-04-12T17:00:00.000Z"
        //   },
        //   {
        //     "count":14,
        //     "tanggal":"2020-04-13T17:00:00.000Z"
        //   },
        //   {
        //     "count":22,
        //     "tanggal":"2020-04-14T17:00:00.000Z"
        //   },
        //   {
        //     "count":15,
        //     "tanggal":"2020-04-15T17:00:00.000Z"
        //   },
        //   {
        //     "count":12,
        //     "tanggal":"2020-04-16T17:00:00.000Z"
        //   },
        //   {
        //     "count":3,
        //     "tanggal":"2020-04-17T17:00:00.000Z"
        //   },
        //   {
        //     "count":3,
        //     "tanggal":"2020-04-18T17:00:00.000Z"
        //   },
        //   {
        //     "count":12,
        //     "tanggal":"2020-04-19T17:00:00.000Z"
        //   },
        //   {
        //     "count":12,
        //     "tanggal":"2020-04-20T17:00:00.000Z"
        //   },
        //   {
        //     "count":10,
        //     "tanggal":"2020-04-21T17:00:00.000Z"
        //   },
        //   {
        //     "count":7,
        //     "tanggal":"2020-04-22T17:00:00.000Z"
        //   }
        // ], length)

      },
      createChart () {
        this.chart = am4core.create(this.$refs.byDate, am4charts.XYChart);

        // Set input format for the dates
        this.chart.dateFormatter.inputDateFormat = "yyyy-MM-dd";

        // Create axes
        let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
        let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

        // Create series
        let series = this.chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = "count";
        series.dataFields.dateX = "tanggal";
        series.tooltipText = "{count}"
        series.strokeWidth = 2;
        series.minBulletDistance = 15;

        // Drop-shaped tooltips
        series.tooltip.background.cornerRadius = 20;
        series.tooltip.background.strokeOpacity = 0;
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.label.minWidth = 40;
        series.tooltip.label.minHeight = 40;
        series.tooltip.label.textAlign = "middle";
        series.tooltip.label.textValign = "middle";

        // Make bullets grow on hover
        let bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.strokeWidth = 2;
        bullet.circle.radius = 4;
        bullet.circle.fill = am4core.color("#fff");

        let bullethover = bullet.states.create("hover");
        bullethover.properties.scale = 1.3;

        // Make a panning cursor
        this.chart.cursor = new am4charts.XYCursor();
        this.chart.cursor.behavior = "panXY";
        this.chart.cursor.xAxis = dateAxis;
        this.chart.cursor.snapToSeries = series;

        // Create vertical scrollbar and place it before the value axis
        this.chart.scrollbarY = new am4core.Scrollbar();
        this.chart.scrollbarY.parent = this.chart.leftAxesContainer;
        this.chart.scrollbarY.toBack();

        // Create a horizontal scrollbar with previe and place it underneath the date axis
        // this.chart.scrollbarX = new am4charts.XYChartScrollbar();
        // this.chart.scrollbarX.series.push(series);
        // this.chart.scrollbarX.parent = this.chart.bottomAxesContainer;

        // dateAxis.start = 0.79;
        // dateAxis.keepSelection = true;
      }
    }
  }
</script>

<style scoped>

</style>